import { Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { SalesByProductTitle } from "../../../../../Constants/Constants";
import { H5, H6, LI, P, ProgressBar, UL } from "../../../../../AbstractElements";
import { AllOverProductSaleData, ChartData, ProgressBarData } from "../../../../../Data/General/Dashboard/Default";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import { MapContainer, TileLayer } from "react-leaflet";
import { IndiaMapProps } from "../../../../../Data/General/Dashboard/Ecommerce";

const SalesByProduct = () => {
  return (
    <Col xxl="6" lg="8" className="box-col-8e">
      <Card className="overflow-hidden">
        <DashboardCommonHeader title={SalesByProductTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="user-continent pb-0">
          <div className="user-map-menu d-flex align-items-center gap-5">
            <div className="user-items">
              <H5>
                2,645<span>items</span>
              </H5>
              <ProgressBar multi>
                {ProgressBarData.map((item, index) => (
                  <ProgressBar bar color={item} value={25} key={index} />
                ))}
              </ProgressBar>
            </div>
            <div className="map-items">
              <UL className="d-flex align-items-center gap-3 simple-list flex-row">
                {ChartData.map((item, index) => (
                  <LI key={index}>
                    <H5>
                      <span className={item.color} />
                      {item.title}
                    </H5>
                    <P className="mb-0">{item.value}</P>
                  </LI>
                ))}
              </UL>
            </div>
          </div>
          <div className="contries-sale d-flex gap-4">
            <div className="map-value">
              <H5>All Over Product Sale</H5>
              <UL className="simple-list">
                {AllOverProductSaleData.map((item, index) => (
                  <LI key={index}>
                    <div className="d-flex gap-2">
                      <div className="flex-shrink-0">
                        <SvgIcon className={item.color} iconId="map-loaction" />
                      </div>
                      <div className="flex-grow-1">
                        <H6>{item.title}</H6>
                      </div>
                      <span>{item.percentage}</span>
                    </div>
                  </LI>
                ))}
              </UL>
            </div>
            <div className="map">
              <div className="jvector-map-height" id="world-map2">
              <MapContainer className="jvector-map-height custom-map" {...IndiaMapProps}>
                <TileLayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" />
              </MapContainer>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SalesByProduct;
